/**
 * يحوّل تاريخ (ISO string أو Date) إلى نص عربي نسبي مبسّط، زي "قبل 5 دقائق" أو "قبل يومين".
 * لو التاريخ أقدم من شهر، بيرجع التاريخ الكامل بدل النص النسبي.
 */
export function timeAgo(dateInput) {
  if (!dateInput) return "";
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);

  if (diffSec < 30) return "الآن";
  if (diffSec < 60) return "منذ لحظات";

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `قبل ${arabicCount(diffMin, "دقيقة", "دقيقتين", "دقائق")}`;

  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `قبل ${arabicCount(diffHour, "ساعة", "ساعتين", "ساعات")}`;

  const diffDay = Math.floor(diffHour / 24);
  if (diffDay < 30) return `قبل ${arabicCount(diffDay, "يوم", "يومين", "أيام")}`;

  return date.toLocaleDateString("ar-EG", { year: "numeric", month: "long", day: "numeric" });
}

function arabicCount(n, singular, dual, plural) {
  if (n === 1) return singular;
  if (n === 2) return dual;
  if (n >= 3 && n <= 10) return `${n} ${plural}`;
  return `${n} ${singular}`;
}
